import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Arquiteto = () => {
  const wpp = generateWhatsAppLink('arquiteto', 'arquiteto-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Arquitetos | Sustenta LED</title>
        <meta name="description" content="LED para arquitetos: especificação técnica e estética. Somos atacadistas e distribuidores com suporte para projetos." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Arquitetos</h1>
              <p>Atendemos arquitetos com soluções de iluminação LED que equilibram estética, eficiência e conforto. Somos atacadistas e distribuidores com portfólio completo para projetos residenciais e comerciais.</p>
              <p>Apoiamos na especificação técnica conforme normas e requisitos do projeto, com produtos homologados e suporte técnico.</p>
              <p>Solicite cotação e receba atendimento especializado para suas demandas.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/banner_quemsomos_sustentaled.jpg" alt="LED para Arquitetos - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Arquiteto;
